<script>
import { md } from "./lib/markdown";
import { gE } from "./lib/utils";

let simplemde = null;

const baseToolbar = [
  "clean-block",
  "heading",
  "heading-bigger",
  "|",
  "bold",
  "italic",
  "strikethrough",
  "code",
  "quote",
  "unordered-list",
  "ordered-list",
  "table",
  "horizontal-rule",
  "|",
  "link",
  "image",
  {
    name: "image-upload",
    action: insertNewImage,
    className: "fa fa-upload",
    title: "Upload image",
  },
  "|",
  "preview",
  "side-by-side",
  "fullscreen",
  "|",
  "guide",
  "|",
  "undo",
  "redo",
];

const plugins = {
  prerender: [
    (text) => text.replace(/=>/g, () => "⇒"),
    (text) => text.replace(/-->/g, () => "⟶"),
  ],
  postrender: [],
};

function insertNewImage(editor) {
  app.vue.$refs.modals.showUploadForm();
}

export default {
  addPlugin(plugType, handler) {
    plugins[plugType].push(handler);
  },
  emits: ["docChanged"],
  data() {
    return {
      markdownText: "",
      editorMode: false,
    };
  },
  computed: {
    editorClass() {
      return this.editorMode ? "editing" : "rendering";
    },
    markdownRender() {
      let source = plugins.prerender.reduce(
        (text, handler) => handler(text),
        this.markdownText
      );
      return plugins.postrender.reduce(
        (text, handler) => handler(text),
        md.render(source)
      );
    },
  },
  methods: {
    replaceSelection(text) {
      return simplemde.codemirror.replaceSelection(text);
    },
    toggleEditor(options) {
      const opts = { save: true, ...options };
      this.editorMode = !this.editorMode;
      if (this.editorMode) {
        this.$originalContent = this.markdownText;
        setTimeout(() => {
          let ta = gE("textarea");
          ta.focus();
          simplemde = new SimpleMDE({
            element: ta,
            autofocus: true,
            toolbar: baseToolbar,
          });
          simplemde.value(this.$originalContent);
        }, 1);
      } else {
        this.markdownText = simplemde.value();
        simplemde.toTextArea();
        if (opts.save) {
          if (this.$originalContent != this.markdownText) {
            this.$emit("docChanged");
          }
        } else {
          this.markdownText = this.$originalContent;
        }
      }
    },
  },
};
</script>
<style lang="scss">
@use 'variables' as vars;

div#editor.rendering {
  padding: 0 1em;
}
div#editor.editing {
  padding: 0;
}

.editor-preview-side {
  background-color: lighten(vars.$background-color, vars.$shade-delta);
}

.dark .editor-preview-side {
  background-color: lighten(vars.$background-color-dark, vars.$shade-delta);
}

div.CodeMirror {
  background-color: vars.$background-color;
  color: vars.$front-color;
}

.dark div.CodeMirror {
  background-color: lighten(vars.$background-color-dark, 10%);
  color: vars.$front-color-dark;
}

.editor-toolbar {
  background-color: white !important;
}

ul.contains-task-list {
  list-style-type: none;
  padding: 0 1ex;
}
a,
a:visited {
  color: darken(vars.$primary-color, vars.$shade-delta);
  text-decoration: none;
}
.dark a,
.dark a:visited {
  color: lighten(vars.$primary-color, 2 * vars.$shade-delta);
}
a:hover {
  text-decoration: underline;
}
pre {
  background: #e4e4e4;
  color: #111;
  padding: 1ex;
  border-radius: 1ex;
  overflow-x: auto;
}

abbr {
  cursor: help;
}
dt {
  font-size: 130%;
}

/* tables formatting */

table {
  border-collapse: collapse;
}

$tableborder: solid 1px vars.$front-color;
$tableborder-dark: solid 1px vars.$front-color-dark;

tr {
  border-bottom: $tableborder;
}
td,
th {
  border-right: $tableborder;
  padding: 0.5ex 1ex;
}
.dark tr {
  border-bottom: $tableborder-dark;
}
.dark td,
.dark th {
  border-right: $tableborder-dark;
}

td:last-child,
th:last-child {
  border-right: none;
}

tbody > tr:last-child {
  border-bottom: none;
}
</style>
<template>
<div id="editor" :class="editorClass">
  <textarea
    tabindex="0"
    v-on:keypress.enter="onReturnKey"
    v-if="editorMode"
    v-model="markdownText"
    v-debounce="500"
  ></textarea>
  <div v-else v-html="markdownRender"></div>
</div>
</template>
